import http from '../../http';
import moment from 'moment';
import _ from 'lodash';

// import EventBus from '../../event_bus';

const fallback_locale = 'en';
const fallback_dir = 'ltr';

const getDefaultLocale = function() {
  return (
    localStorage.getItem('locale') ||
    navigator.language ||
    navigator.userLanguage ||
    fallback_locale
  );
};

const state = {
  i18n: window.i18n,
  locales: window._locales,
  locale: getDefaultLocale(),
  is_loading: false,
  dir: fallback_dir,
};

const getters = {
  getLocales: function(state, getters) {
    return state.locales;
  },

  getLocale: function(state, getters) {
    return state.locale;
  },
};

const mutations = {
  applyLocaleLoading: function(state, locale) {
    state.i18n = window.i18n;
    state.is_loading = true;
  },

  applyLocaleWasLoaded: function(state, data) {
    let old_locale = state.locale;
    let new_locale = data.locale;

    state.i18n = data.translations;
    state.locale = data.locale;
    state.is_loading = false;
    localStorage.setItem('locale', data.locale);

    // set direction
    state.dir = _.get(state.locales, data.locale + '.dir', 'ltr');

    // set date locale
    moment.locale(state.locale || fallback_locale);

    // set direction to <html>
    document.dir = state.dir;
    document.documentElement.lang = state.locale;

    // if (old_locale != new_locale) {
    // 	EventBus.$emit('language.change', state.locale);
    // }
  },

  applyLocaleFailed: function(state, error) {
    state.i18n = window.i18n;
    state.is_loading = false;
  },
};

const actions = {
  setLocale(context, locale) {
    if (typeof locale === 'undefined') {
      locale = getDefaultLocale();
    }
    context.commit('applyLocaleLoading', locale);
    return http
      .get('/i18n?lang=' + locale)
      .then((response) => {
        context.commit('applyLocaleWasLoaded', {
          translations: response.data,
          locale: locale,
        });
      })
      .catch((error) => {
        context.commit('applyLocaleFailed', error);
        // context.commit('putErrorMessages', error, { root: true });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
